<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="800">
    <v-card v-if="rows != null">
      <ODialogBar
        title="Snapshot de Variáveis"
        @close="$refs.dialog.$dismiss"
      />
      <v-card-text>
        <v-text-field placeholder="Filtrar..." v-model="keywords" />
      </v-card-text>
      <ODataTable :items="filteredItems" :spec="spec" />
    </v-card>
  </ODialog>
</template>

<script>
import ODataTable from 'oderon-vue/cpts/ODataTable.vue'
import { Client } from '@/models'
import { matchAnyLike } from 'oderon-commons/src/utils'
import { smartDtTime } from 'oderon-vue/utils'

export default {
  components: { ODataTable },
  data() {
    return {
      clientId: null,
      rows: null,
      keywords: null,
      spec: [
        { t: 'Variável', d: 'code' },
        { t: 'Valor|', d: 'value' },
        { t: 'HB|', d: 'hbId' },
        { t: 'Data HB|', d: 'hbRecvOn', f: smartDtTime },
        { t: 'Mudou em|', d: 'changedAt', f: smartDtTime },
        { t: 'Criado em|', d: 'createdAt', f: smartDtTime }
      ]
    }
  },
  computed: {
    filteredItems() {
      if (this.rows == null) return null

      return this.rows.filter((x) =>
        matchAnyLike(this.keywords, x.code, x.value)
      )
    }
  },
  methods: {
    open(clientId) {
      this.clientId = clientId
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      let res = await Client.findById(this.clientId)
      this.rows = res.variables || []
    }
  }
}
</script>

<style></style>
